// Pulls dashboard paths needed by the shared surface shell (e.g. inbox detection).
// The full route registry, including issues paths, lives in each consuming app.
export const PULLS_PATH = '/pulls'
export const PULLS_INBOX_PATH = '/pulls/inbox'
